// extracted by mini-css-extract-plugin
module.exports = {"skillGroupTitle":"TechSkillsTab_skillGroupTitle__up1vA","skillGroupLevel":"TechSkillsTab_skillGroupLevel__3cjxe","tableContainer":"TechSkillsTab_tableContainer__3PIFN"};